import React from 'react';

class InputTuKhoa extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value
    }
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {   
    this.setState({
      value: nextProps.value
    }); 
  }

  render() {
    return (
      <div className="input-group-show">
        <label className="ip-label">Từ khoá</label>
        <input type="text" name="searchKey" placeholder={ this.props.placeholderText } className="search-input" onChange={ this.onChange.bind(this) } 
          value={this.state.value}/>
      </div>
      );
  }
}

InputTuKhoa.defaultProps = {
  placeholderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  value: '',
  onChange: function() {
    console.log('Please assign onChange function');
  }
}

export default InputTuKhoa;



// WEBPACK FOOTER //
// ./src/components/modules/reception/form-timkiem/input-tukhoa.js